<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const hasInboxAvatar = computed(() => Boolean(props.inbox?.avatar_url));
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-0.5 min-w-0">
    <img
      v-if="hasInboxAvatar"
      :src="inbox.avatar_url"
      :alt="inbox.name"
      width="16"
      height="16"
      loading="lazy"
      decoding="async"
      fetchpriority="low"
      class="size-4 min-w-4 flex-shrink-0 rounded-sm object-cover"
    />
    <ChannelIcon
      v-else
      :inbox="inbox"
      class="size-4 flex-shrink-0 text-n-slate-11"
    />
    <span class="truncate text-label-small text-n-slate-11">
      {{ inbox.name }}
    </span>
  </div>
</template>
